import { useAction } from '@wix/da-hooks/pkg/useAction';
import { useSelector } from 'react-redux';
import { getPushSubscriptionState, getPushSubscriptions } from './selectors';
import { togglePushSubscription, registerPushSubscription, unregisterPushSubscription, updatePushSubscriptions } from './actions';
import { PushSubscriptionState } from './types';
export function usePushSubscription() {
    const state = useSelector(getPushSubscriptionState);
    return {
        state,
        isSubscribed: state === PushSubscriptionState.SUBSCRIBED,
        canToggle: [
            PushSubscriptionState.SUBSCRIBED,
            PushSubscriptionState.READY_TO_SUBSCRIBE
        ].includes(state),
        toggle: useAction(togglePushSubscription),
        register: useAction(registerPushSubscription),
        unregister: useAction(unregisterPushSubscription)
    };
}
// get a PushSubscriptions map to see which notifications the user subscribed to
export function usePushSubscriptions() {
    const subscriptions = useSelector(getPushSubscriptions);
    const setSubscriptions = useAction(updatePushSubscriptions);
    return [
        subscriptions,
        setSubscriptions
    ];
}

//# sourceMappingURL=hooks.js.map